module.exports = __webpack_public_path__ + "static/media/4.c0f5e0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/4.jpg
// module id = 596
// module chunks = 0